module.exports = __webpack_public_path__ + "static/media/tpn-mockup-5.b353e3ff.jpg";